module.exports = __webpack_public_path__ + "static/media/homepage-banner-id-restoration-icon.13388e21.svg";